/* TrendyBits — Cart Drawer JS
   Save as: assets/tb-cart-drawer.js
   This is a JavaScript file. It must live in the assets/ folder.
   It's loaded in theme.liquid via <script> tag (we'll wire that up in File 7).
*/

(function() {
  'use strict';

  function init() {
    var root = document.getElementById('tb-drawer-root');
    if (!root) return;

    // Move the drawer + overlay to <body> root so position:fixed
    // can't be hijacked by a parent with `transform`, `filter`, or `contain`.
    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var drawer = document.getElementById('tb-drawer');
    var overlay = document.getElementById('tb-drawer-overlay');
    if (!drawer || !overlay) return;

    var isOpen = false;
    var isUpdating = false;

    // ===== OPEN / CLOSE =====
    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tb-drawer-locked');
      isOpen = true;
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tb-drawer-locked');
      isOpen = false;
    }

    // Make these globally available
    window.tbCartDrawer = {
      open: openDrawer,
      close: closeDrawer,
      refresh: refreshDrawer
    };

    // ===== Cart button handler (qty +/-, remove, promo apply) =====
    function handleCartButton(e) {
      // Decrease quantity
      var dec = e.target.closest('[data-tb-cart-decrease]');
      if (dec) {
        e.preventDefault();
        var key = dec.getAttribute('data-tb-cart-key');
        var qty = parseInt(dec.getAttribute('data-tb-current-qty'), 10) || 1;
        updateLine(key, Math.max(0, qty - 1));
        return;
      }
      // Increase quantity
      var inc = e.target.closest('[data-tb-cart-increase]');
      if (inc) {
        e.preventDefault();
        var keyI = inc.getAttribute('data-tb-cart-key');
        var qtyI = parseInt(inc.getAttribute('data-tb-current-qty'), 10) || 0;
        updateLine(keyI, qtyI + 1);
        return;
      }
      // Remove
      var rem = e.target.closest('[data-tb-cart-remove]');
      if (rem) {
        e.preventDefault();
        var keyR = rem.getAttribute('data-tb-cart-key');
        updateLine(keyR, 0);
        return;
      }
      // Promo code apply
      var promo = e.target.closest('[data-tb-promo-apply]');
      if (promo) {
        e.preventDefault();
        applyPromoCode();
        return;
      }
    }

    // ===== Drawer event delegation =====
    drawer.addEventListener('click', function(e) {
      if (e.target.closest('[data-tb-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      handleCartButton(e);
    });

    // ===== Cart page event delegation (full /cart page) =====
    document.addEventListener('click', function(e) {
      if (e.target.closest('#tb-drawer')) return; // Already handled
      if (!e.target.closest('[data-tb-cart-page]')) return;
      handleCartButton(e);
    });

    // Close on overlay click
    overlay.addEventListener('click', closeDrawer);

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });

    // ===== Intercept cart icon links =====
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-tb-cart-trigger]');
      if (!trigger) return;
      if (trigger.closest('#tb-drawer')) return;
      var href = trigger.getAttribute('href') || '';
      if (href.indexOf('/checkout') !== -1) return;

      e.preventDefault();
      openDrawer();
    });

    // ===== Intercept add-to-cart form submissions =====
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add?"], form[action*="/cart/add.js"]');
      if (!form) return;
      e.preventDefault();
      addToCart(form);
    });

    function addToCart(form) {
      var formData = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(err) { throw err; });
        return r.json();
      })
      .then(function() { return refreshDrawer(); })
      .then(function() { openDrawer(); })
      .catch(function(err) {
        console.error('Add to cart failed', err);
        if (err && err.description) alert(err.description);
      })
      .finally(function() { if (btn) btn.disabled = false; });
    }

    // ===== Update line item via /cart/change.js =====
    function updateLine(key, quantity) {
      if (isUpdating || !key) return;
      isUpdating = true;
      drawer.classList.add('is-loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(err) { throw err; });
        return r.json();
      })
      .then(function() { return refreshDrawer(); })
      .then(function() { return refreshFullCartIfPresent(); })
      .catch(function(err) { console.error('Cart update failed', err); })
      .finally(function() {
        isUpdating = false;
        drawer.classList.remove('is-loading');
      });
    }

    // ===== Apply promo code (redirects to checkout with discount auto-applied) =====
    function applyPromoCode() {
      var input = document.querySelector('[data-tb-promo-input]');
      var feedback = document.querySelector('[data-tb-promo-feedback]');
      if (!input) return;
      var code = input.value.trim();
      if (!code) {
        if (feedback) {
          feedback.textContent = 'Enter a code first';
          feedback.className = 'tb-cart-summary__promo-feedback is-error';
        }
        return;
      }
      if (feedback) {
        feedback.textContent = 'Taking you to checkout to apply…';
        feedback.className = 'tb-cart-summary__promo-feedback is-info';
      }
      window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    }

    // ===== Refresh drawer contents via Shopify section render API =====
    function refreshDrawer() {
      return fetch('/?sections=tb-cart-drawer-bits', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function(r) {
        if (!r.ok) throw new Error('section render failed');
        return r.json();
      })
      .then(function(data) {
        var html = data['tb-cart-drawer-bits'];
        if (!html) return;

        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var newBody = tmp.querySelector('[data-tb-drawer-body]');
        var oldBody = drawer.querySelector('[data-tb-drawer-body]');
        if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;

        var newFoot = tmp.querySelector('[data-tb-drawer-foot]');
        var oldFoot = drawer.querySelector('[data-tb-drawer-foot]');
        if (newFoot) {
          if (oldFoot) {
            oldFoot.replaceWith(newFoot);
          } else {
            drawer.appendChild(newFoot);
          }
        } else if (oldFoot) {
          oldFoot.remove();
        }

        var newCount = tmp.querySelector('[data-tb-drawer-count]');
        var oldCount = drawer.querySelector('[data-tb-drawer-count]');
        if (newCount && oldCount) oldCount.innerHTML = newCount.innerHTML;

        updateHeaderCartCounts();
      })
      .catch(function(err) { console.error('Drawer refresh failed:', err); });
    }

    function updateHeaderCartCounts() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var els = document.querySelectorAll('[data-tb-cart-count]');
          for (var i = 0; i < els.length; i++) {
            els[i].textContent = cart.item_count;
            els[i].classList.toggle('is-empty', cart.item_count === 0);
          }
        })
        .catch(function() {});
    }

    function refreshFullCartIfPresent() {
      if (!document.querySelector('[data-tb-cart-page]')) return Promise.resolve();
      return fetch('/?sections=tb-cart-page', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data['tb-cart-page'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newPage = tmp.querySelector('[data-tb-cart-page]');
        var oldPage = document.querySelector('[data-tb-cart-page]');
        if (newPage && oldPage) oldPage.replaceWith(newPage);
      })
      .catch(function() {});
    }

    updateHeaderCartCounts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
